export default __webpack_public_path__ + "c71ec4cea127e287db46c90ded17572e.jpg";